module.exports = __webpack_public_path__ + "static/media/eletricTower.a9c341d2.svg";